import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { templateKeys } from './useTemplates';
import type { Template } from '../../lib/types/template.types';

/**
 * Duplicate a template mutation
 * Creates a copy with "Copy of " prefix
 *
 * @returns Mutation object with mutate function
 *
 * @example
 * const duplicateTemplate = useDuplicateTemplate();
 * duplicateTemplate.mutate(templateId);
 */
export function useDuplicateTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.post<Template>(`/api/templates/${id}/duplicate`);
      return data;
    },
    onSuccess: () => {
      // Invalidate lists to show new template
      queryClient.invalidateQueries({ queryKey: templateKeys.lists() });
    },
  });
}
